import axios from "axios";
import Info from "./info.json";

class Api_Call {
  constructor() {}
  async getData(endpoint, baseUrl = Info.BASE_URL) {
    try {
      const url = `${baseUrl}${Info.INSTACE}/${endpoint}`;

      const response = await axios.get(url);
      console.log("response IS:", response);
      return response.data;
    } catch (error) {
      console.error("Error fetching data:", error);
      return null;
    }
  }

  async postData(endpoint, body, baseUrl = Info.BASE_URL) {
    try {
      const url = `${baseUrl}${Info.INSTACE}/${endpoint}`;
      const response = await axios.post(url, body, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      console.log(response.data);
      return response.data;
    } catch (error) {
      console.error("Error posting data:", error);
      return null;
    }
  }

  async putData(endpoint, body, baseUrl = Info.BASE_URL) {
    try {
      const url = `${baseUrl}${Info.INSTACE}/${endpoint}`;
      const response = await axios.put(url, body);
      return response.data;
    } catch (error) {
      console.error("Error updating data:", error);
      return null;
    }
  }

  async deleteData(endpoint, payload, baseUrl = Info.BASE_URL) {
    try {
      const url = `${baseUrl}${Info.INSTACE}/${endpoint}`;
      const response = await axios.delete(url, { data: payload });
      return response.data;
    } catch (error) {
      console.error("Error deleting data:", error);
      return null;
    }
  }

  async patchData(endpoint, payload, baseUrl = Info.BASE_URL) {
    try {
      const url = `${baseUrl}${Info.INSTACE}/${endpoint}`;
      const response = await axios.patch(url, payload);
      return response.data;
    } catch (error) {
      console.error("Error patching data:", error);
      // You might want to handle or log the error differently here
      throw error;
      return null;
    }
  }
}

export default Api_Call;
